import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-06270473"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 0,
  class: "profile-panel__mobile-section"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile-panel__divider" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxTabsMobile = _resolveComponent("PxTabsMobile")!
  const _component_ContentPlaceholdersText = _resolveComponent("ContentPlaceholdersText")!
  const _component_PxPanelSection = _resolveComponent("PxPanelSection")!
  const _component_PxPanel = _resolveComponent("PxPanel")!
  const _component_PxCornerRibbon = _resolveComponent("PxCornerRibbon")!

  return (_openBlock(), _createBlock(_component_PxCornerRibbon, {
    hidden: _ctx.isInvestorsPanelEnabled || !_ctx.hasUserAccess,
    class: "px-corner-ribbon--center-xs"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_PxPanel, {
        class: "profile-panel profile-panel--investors profile-panel--inactive",
        theme: "with-sections"
      }, {
        header: _withCtx(() => [
          _createElementVNode("h2", {
            class: "px-panel__title",
            innerHTML: _ctx.$t('profile.investors.title')
          }, null, 8, _hoisted_1)
        ]),
        default: _withCtx(() => [
          (_ctx.$screen.smDown)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_PxTabsMobile, {
                  modelValue: _ctx.selectedTab,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTab) = $event)),
                  items: _ctx.tabsMobileItems,
                  disabled: ""
                }, null, 8, ["modelValue", "items"]),
                _createVNode(_component_ContentPlaceholdersText, {
                  lines: 3,
                  class: "profile-panel__mobile-text"
                }),
                _hoisted_3,
                _createVNode(_component_ContentPlaceholdersText, {
                  lines: 3,
                  class: "profile-panel__mobile-text"
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.$screen.mdUp)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_PxPanelSection, {
                  title: _ctx.$t('profile.investors.nextMilestones'),
                  icon: "flag--outlined"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ContentPlaceholdersText, { lines: 4 })
                  ]),
                  _: 1
                }, 8, ["title"]),
                _createVNode(_component_PxPanelSection, {
                  title: _ctx.$t('profile.investors.achievedMilestones'),
                  icon: "flag--checked"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ContentPlaceholdersText, { lines: 4 })
                  ]),
                  _: 1
                }, 8, ["title"])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["hidden"]))
}